export default __webpack_public_path__ + "static/cert1-2d0b4e627a51a0ea56b41357a58d171a.jpg";